function toNumber(value) {
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
}

function isInactive(row = {}) {
  return Boolean(
    row.inactive === true ||
      row.excluded === true ||
      row?.flags?.inactive === true ||
      row?.flags?.excluded === true ||
      row?.meta?.inactive === true ||
      row?.meta?.excluded === true
  );
}

function getRawRowTotal(row = {}) {
  if (row?.total !== undefined && row?.total !== null) {
    return toNumber(row.total);
  }

  const quantity = toNumber(row?.quantity ?? row?.qty ?? row?.hours);
  const unitPrice = toNumber(
    row?.unitPrice ?? row?.price ?? row?.hourlyRate ?? row?.rate
  );

  return quantity * unitPrice;
}

function getLabel(type) {
  switch (type) {
    case "material":
      return "Materials";
    case "labour":
      return "Labour";
    case "extra":
      return "Extras";
    default:
      return "Other";
  }
}

function getSortOrder(type) {
  switch (type) {
    case "material":
      return 0;
    case "labour":
      return 1;
    case "extra":
      return 2;
    default:
      return 99;
  }
}

function normalizeType(type) {
  const value = String(type || "").toLowerCase();

  if (value === "materials") return "material";
  if (value === "labour" || value === "labor") return "labour";
  if (value === "extras") return "extra";

  return value || "extra";
}

export function groupSectionGroupsBySourceType(rows = []) {
  if (!Array.isArray(rows)) return [];

  const grouped = new Map();

  for (const row of rows) {
    const type = normalizeType(row?.type || row?.rowKind);

    if (!grouped.has(type)) grouped.set(type, []);

    grouped.get(type).push(row);
  }

  return Array.from(grouped.entries())
    .map(([type, groupRows]) => {
      const inactiveRows = groupRows.filter(isInactive);
      const activeRows = groupRows.filter((row) => !isInactive(row));

      const total = activeRows.reduce(
        (sum, row) => sum + getRawRowTotal(row),
        0
      );

      const rawTotal = groupRows.reduce(
        (sum, row) => sum + getRawRowTotal(row),
        0
      );

      const inactiveTotal = inactiveRows.reduce(
        (sum, row) => sum + getRawRowTotal(row),
        0
      );

      return {
        id: type,
        type,
        label: getLabel(type),
        rows: groupRows,
        rowCount: groupRows.length,

        activeRows,
        inactiveRows,

        activeRowCount: activeRows.length,
        inactiveRowCount: inactiveRows.length,

        total,
        rawTotal,
        inactiveTotal,

        // Backwards compatibility
        excludedRows: inactiveRows,
        excludedRowCount: inactiveRows.length,
        excludedTotal: inactiveTotal,
      };
    })
    .sort((a, b) => getSortOrder(a.type) - getSortOrder(b.type));
}